import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eeeda0f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "correct" }
const _hoisted_2 = { class: "expr" }
const _hoisted_3 = {
  key: 0,
  class: "lineOne"
}
const _hoisted_4 = {
  key: 1,
  class: "lineOne"
}
const _hoisted_5 = {
  key: 2,
  class: "lineTwo"
}
const _hoisted_6 = {
  key: 3,
  class: "lineTwo"
}
const _hoisted_7 = {
  key: 0,
  class: "answer"
}
const _hoisted_8 = {
  key: 1,
  class: "answer"
}
const _hoisted_9 = {
  key: 2,
  class: "answer"
}
const _hoisted_10 = {
  key: 3,
  class: "answer"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jiexi" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "jiexiTitle" }, "答案解析:"),
  /*#__PURE__*/_createElementVNode("div", { class: "jiexiDetail" }, [
    /*#__PURE__*/_createElementVNode("span", null, "特应性皮炎外用制剂合理应用及患者指导专家共识指出："),
    /*#__PURE__*/_createTextVNode(" AD继发感染时，推荐抗炎制剂联合使用外用抗菌药物 如常用的含2%莫匹罗星软膏7-14天 ")
  ])
], -1))
const _hoisted_12 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($props.correct == 1)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 0,
              width: "2rem",
              height: "2rem",
              src: require('../assets/smile.png')
            }, null, 8, ["src"]))
          : _createCommentVNode("", true),
        ($props.correct == 0)
          ? (_openBlock(), _createBlock(_component_van_image, {
              key: 1,
              width: "2rem",
              height: "2rem",
              src: require('../assets/cry.png')
            }, null, 8, ["src"]))
          : _createCommentVNode("", true)
      ]),
      ($props.correct == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "太棒了"))
        : _createCommentVNode("", true),
      ($props.correct == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "判断错误"))
        : _createCommentVNode("", true),
      ($props.correct == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "判断正确"))
        : _createCommentVNode("", true),
      ($props.correct == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "要继续加油哦"))
        : _createCommentVNode("", true),
      _createVNode(_component_van_radio_group, {
        modelValue: $data.radioVal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.radioVal) = $event))
      }, {
        default: _withCtx(() => [
          ($props.postaimqus == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, " 答案解密：" + _toDisplayString($data.questions[$props.postaimqus].radioList[0].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " 答案解密：" + _toDisplayString($data.questions[$props.postaimqus].radioList[2].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 答案解密：" + _toDisplayString($data.questions[$props.postaimqus].radioList[3].title), 1))
            : _createCommentVNode("", true),
          ($props.postaimqus == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 答案解密：" + _toDisplayString($data.questions[$props.postaimqus].radioList[3].title), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_van_image, {
        onClick: $options.nexStep,
        width: "2.5733rem",
        height: "2.5733rem",
        src: require('../assets/jixu.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ])
  ], 64))
}